import { render } from "./ConversionsTable.vue?vue&type=template&id=56c109c3&scoped=true&ts=true"
import script from "./ConversionsTable.vue?vue&type=script&lang=ts"
export * from "./ConversionsTable.vue?vue&type=script&lang=ts"

import "./ConversionsTable.vue?vue&type=style&index=0&id=56c109c3&lang=scss&scoped=true"

import exportComponent from "/root/source/core/frontend/affiliate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c109c3"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTd});
